export default __webpack_public_path__ + "static/media/red_dot.3af15bef.svg";